import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { sectors } from '../../data/sectors';

const Sectors = () => (
  <Box component="section" id="sectors" sx={{ py: { xs: 8, md: 10 }, backgroundColor: 'background.default' }}>
    <Container>
      <Grid container spacing={4} alignItems="center">
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="overline" color="secondary">
            Markets Served
          </Typography>
          <Typography variant="h2" sx={{ mt: 1, color: 'primary.main' }}>
            Experience in occupied and critical environments
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Our teams deliver mechanical scopes in government buildings, healthcare campuses, higher education, and
            high-rise developments—coordinating phasing and infection control requirements without disrupting occupants.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <Grid container spacing={3}>
            {sectors.map((sector) => (
              <Grid size={{ xs: 12, sm: 6 }} key={sector}>
                <Card sx={{ height: '100%', borderLeft: '4px solid', borderColor: 'secondary.main' }}>
                  <CardContent>
                    <Typography variant="h6">{sector}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default Sectors;
